import { HTTP_API_BASE_URL } from '@rootCommon/constants/common';
import { DOWNLOAD } from '@rootCommon/constants/end-points';
import { Message } from '@rootCommon/services';
import { mustBeLessMb } from '@rootCommon/constants/validation/validation-messages';
import { IdType } from '@rootCommon/types/common';

export const getFilePath = (id: IdType): string => `${HTTP_API_BASE_URL || ''}/${DOWNLOAD}?fileId=${id}`;

export const beforeUploadImage = (file: File, sizeMb: number): boolean => {
  const isLess = file.size / 1024 / 1024 < sizeMb;

  if (!isLess) {
    Message.error(mustBeLessMb(sizeMb));
  }

  return isLess;
};
